// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__5219y","heading":"menu_heading__m1R6E","secondary":"menu_secondary__Q3vLp"};